/*global angular*/
module.exports = ['settings', function (settings) {
  'use strict';
  return {
    restrict: 'E',
    template: require('./music.html'),
    replace: true,
    transclude: true,
    scope: {
      content: '=data'
    },
    link: function (scope) {
      scope.musicUrl = settings.apisAndUrls.cachedApi + scope.content.attachments.filter(o => o.type === 'ATTACHMENT')[0].href;
    }
  };
}];




// WEBPACK FOOTER //
// ./web/js/module/practicalExample/js/music/music.js